import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getDashboardAssetSummaryPerOrganizationExport } from '@api/dashboardPO';

import { TDashboardSummaryPerOrganizationExportDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { ESnackbarTypes } from '@enums/common';

import { DASHBOARD_ASSET_SUMMARY_PER_ORGANIZATION_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useMutateDashboardAssetSummaryPerOrganizationsExport() {
	const dispatch = useAppDispatch();

	const {
		mutate: exportDashboardAssetSummaryPerOrganizations,
		isLoading: isLoadingExportDashboardAssetSummaryPerOrganizations,
	} = useMutation<TDashboardSummaryPerOrganizationExportDTO>({
		mutationKey: [DASHBOARD_ASSET_SUMMARY_PER_ORGANIZATION_EXPORT],
		mutationFn: getDashboardAssetSummaryPerOrganizationExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportDashboardAssetSummaryPerOrganizations,
		isLoadingExportDashboardAssetSummaryPerOrganizations,
	};
}
